var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-offboarding',[_c('pixi-sprite',{attrs:{"z-index":1,"x":970,"y":212,"anchor-x":0.5,"anchor-y":0.5,"image-path":"/images/game/w3d1/end_bubble.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }